import { Box, BoxProps, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC } from 'react'
import { loginStrings, staticStrings } from '../../../data/static/strings'
import { Routes } from '../../../nav/routes'
import { APIEndPoints } from '../../../network/APIEndpoints'
import { testProps } from '../../../util/util'

interface FooterProps {
  footerStyles: any
  hide?: boolean
}

const fStyles = {
  container: {
    marginHorizontal: 16,
  } as BoxProps,
}
const Footer: FC<FooterProps> = ({ footerStyles, hide }: FooterProps) => {
  const { navigate } = useNavigation()

  if (hide) {
    return null
  }

  const onPrivacyPolicyClicked = () => {
    window.open(APIEndPoints.privactPolicy, staticStrings.targetBlank)
  }
  const onContactUsClicked = () => {
    navigate(Routes.CONTACT_US_LOGIN)
  }
  const onTermsNConditionsClicked = () => {
    window.open(APIEndPoints.tnc, staticStrings.targetBlank)
  }
  const handleGrevienceRedressalNavigation = (): void => {
    window.open(APIEndPoints.grevienceRedressal, staticStrings.targetBlank)
  }
  const handlekycAMLNavigation = (): void => {
    window.open(APIEndPoints.kycAML, staticStrings.targetBlank)
  }
  return (
    <Box {...footerStyles.footerStyle}>
      <Box {...fStyles.container} onPress={onPrivacyPolicyClicked}>
        <Text type={'footnote'} {...testProps('privacy-link')} color={'WHITE'}>
          {loginStrings.privacyPolicy}
        </Text>
      </Box>
      <Text {...footerStyles.dotStyle}>●</Text>
      <Box {...fStyles.container} onPress={onContactUsClicked}>
        <Text type={'footnote'} {...testProps('contact-link')} color={'WHITE'}>
          {loginStrings.contactUs}
        </Text>
      </Box>
      <Text {...footerStyles.dotStyle}>●</Text>
      <Box {...fStyles.container} onPress={onTermsNConditionsClicked}>
        <Text type={'footnote'} {...testProps('tnc-link')} color={'WHITE'}>
          {loginStrings.termsNConditions}
        </Text>
      </Box>
      <Text {...footerStyles.dotStyle}>●</Text>
      <Box {...fStyles.container} onPress={handleGrevienceRedressalNavigation}>
        <Text type={'footnote'} {...testProps('grevience-redressal')} color={'WHITE'}>
          {staticStrings.grevienceRedressal}
        </Text>
      </Box>
      <Box {...fStyles.container} onPress={handlekycAMLNavigation}>
        <Text type={'footnote'} {...testProps('grevience-redressal')} color={'WHITE'}>
          {staticStrings.kycAML}
        </Text>
      </Box>
    </Box>
  )
}
export default Footer
